import { BrowserRouter as Router } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import CommandMenu from './components/CommandMenu';

import AnimatedRoutes from './AnimatedRoutes';
import CustomCursor from './components/CustomCursor';
import FutoraChatbot from './components/FutoraChatbot';
import './index.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Analytics />
      <div className="App">
        <CustomCursor />
        <Navbar />
        <CommandMenu />
        <FutoraChatbot />

        <main>
          <AnimatedRoutes />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
